var React = require('react');

function Icon(props) {
  return React.cloneElement(
    React.createElement(
      'svg',
      { height: '24', width: '24', viewBox: '0 0 24 24' },
      React.createElement('path', { d: 'M3.9 3H20.1L21 3.9V20.1L20.1 21H3.9L3 20.1V3.9L3.9 3ZM5 19H19.0001V5H5V19Z' })
    ),
    props
  );
}

module.exports = Icon;
